import type { FormJSONObject } from '@ikegps/core-api';
import type { FormModel } from '../../model/form/form';
import { type IkeCacheObject, IkeRestObject } from './base';

export class IkeObjectForm extends IkeRestObject<FormJSONObject> {
	className = 'Form' as const;
	actionName = 'form';
	object?: FormJSONObject;

	constructor() {
		super();
		this.cacheKeys['revision'] = true;

		// Required for mapsight-web form designer
		this.cacheKeys['version'] = true;
	}
}

export const IkeObjectFormModel: IkeCacheObject<FormModel> = {
	className: 'FormModel',
	actionName: 'form.model',

	canCache<K extends keyof FormModel>(key: K): boolean {
		return key === 'revision' || key === 'version';
	},
};
